/** Design <-> URL-hash serialization for shareable links. */
import type { Design } from "../model/fill";

export function hashFromDesign(design: Design): string {
  const json = JSON.stringify(design);
  return "#d=" + btoa(String.fromCharCode(...new TextEncoder().encode(json)))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replace(/=+$/, "");
}

export function designFromHash(): Design | null {
  if (typeof location === "undefined") return null;
  const m = location.hash.match(/^#d=([A-Za-z0-9_-]+)$/);
  if (!m) return null;
  try {
    const b64 = m[1]!.replaceAll("-", "+").replaceAll("_", "/");
    const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
    const d = JSON.parse(new TextDecoder().decode(bytes)) as Design;
    // Light shape check; a bad link falls back to defaults.
    if (!d || typeof d !== "object" || !d.fill?.kind || !d.unit || !d.sweep) return null;
    return d;
  } catch {
    return null;
  }
}
